// eslint-disable-next-line
import tw from "twin.macro";
import React from "react";
//import all child components
import { Container } from "../components/Contact/ContactStyle";
import CompanyInfo from "../components/Contact/CompanyInfo";
import ContactForm from "../components/Contact/ContactForm";
import circle from "../icons/circle.svg";
import Seo from "../components/Seo";
import Title from "../components/Title";
import Layout from "../components/Layout";

const Contact = () => {
  return (
    <Layout>
      <Seo title="Get a Quote" description="If you have any questions, concerns or issues, we're here to help. Check here to find the answers to your questions here and get in touch with us if you need to." />

      <div
        style={{ backgroundImage: `url(${circle})` }}
        tw="bg-no-repeat bg-cover bg-center bg-gray-700 text-white min-h-screen grid place-items-center"
      >
        <Container tw="space-y-10  p-5">
          <Title title="Get a Quote" />
          <Container
            wrapper
            tw="bg-gradient-to-r from-gray-600  to-gray-700  text-white! rounded-3xl "
          >
            <div tw="background-color[#ff1c1c] p-5 rounded-2xl">
              <CompanyInfo />
            </div>
            <div tw="p-5">
              <ContactForm />
            </div>
          </Container>
        </Container>
      </div>
    </Layout>
  );
};

export default Contact;
